export default function sortAlphabetically(items: any) {
    const arr = items.sort((a: any, b: any) => a.title.localeCompare(b.title));
    return arr.reduce((groups: any, item: any) => {
        const { title } = item;
        const letter = isNaN(+title) ? title.charAt(0) : '#';
        const groupIndex = groups.findIndex(({ letter: groupLetter }: any) => groupLetter === letter);
        groupIndex !== -1 ? groups[groupIndex].items.push(item) : groups.push({ letter, items: [item] });
        return groups;
    }, []);
}